import React from 'react'
import { Modal } from 'react-bootstrap'
export type ModalDragHandleProps = { children?: any }
export const ModalDragHandle = ({ children }: ModalDragHandleProps) => {
  return (
    <Modal.Header closeButton className="drag-handle" style={{ cursor: 'move' }}>
      {children}
    </Modal.Header>
  )
}
